<template>
<div id="app">
  <v-app>
    <img src="./assets/logo.png" class="logo-style"/>
    <v-btn
            v-scroll="onScroll"
            v-show="fab"
            fab
            dark
            fixed
            bottom
            right
            color="cyan darken-2"
            @click="toTop"
          >
            <v-icon>mdi-arrow-up</v-icon>
    </v-btn>

    <v-app-bar app text-center color="white" height="100">
      <v-container class="py-0 fill-height">
        <v-spacer />
        <v-app-bar-title class="title-style">
          <img class='titleimg-style' src="./assets/title.png" />
        </v-app-bar-title>
        <v-spacer />
      </v-container> 
    </v-app-bar>


    <!--功能列 MENU螢光綠#76ff03  蘋果綠#CCFF90  https://vuetifyjs.com/en/styles/colors/#material-colors--> 
  <v-card class="menu-style">
    <v-tabs
        background-color="#CCFF90"  
        centered
        color="black"
        next-icon="mdi-arrow-right"
        prev-icon="mdi-arrow-left"
        show-arrows
      >
      <v-tab v-for="item, index in menus"
        :key="item.title"
        :to="item.routerName"
        class="font-weight-bold text-h6"
        @click="changeTab(item.routerName )"
        >
        <v-tooltip bottom>
        <template v-slot:activator="{on}">
          <span v-on="on">{{item.title}}</span>
        </template>
        {{menus[index].tip}}
        </v-tooltip>

      </v-tab>


      </v-tabs>
    <!--
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">

      <v-tabs
        background-color="cyan darken-2"
        centered
        dark
        next-icon="mdi-arrow-right"
        prev-icon="mdi-arrow-left"
        show-arrows
      >
      <v-tab v-for="item in menus"
        :key="item.title"
        :to="item.routerName"
        class="font-weight-bold text-subtitle-1"
        v-bind="attrs"
        v-on="on"
        >
        {{item.title}}

      </v-tab>


      </v-tabs>
      </template>
        {{menus[1].tip}}
      </v-tooltip>
      --> 

  </v-card>
  <!--各頁版面宣告--> 
  <v-container id='routerdiv' class="router-style">
    <router-view></router-view>
  </v-container>
  <!--置底列--> 
  <div id='footerdiv' style="border:2px;solid;red">
    <v-card
      flat
      tile
      dark
      color="#778899"
      class="footer-style"
      :style="footerStyles"
    >
    <v-card-text class="white--text">
        <v-row><v-col class="pl-10 white--text text-left" cols="12" xs="12" sm="6">
        03-4926360    /    03-4926268<br>
        桃園市中壢區正泰街16號（中壢婦幼館正對面）<br>
        ALL RIGHT RESERVED</v-col>
        <v-col class="pr-10 white--text text-right">桃園市私立福曼珊幼兒園<br>府教幼字第1040038112號</v-col></v-row>
      </v-card-text>
    </v-card>
  </div>
  </v-app>
</div>
</template>
<script>
 export default {
  name: 'App',
  mounted() {
    window.addEventListener('resize', this.resize);
    document.oncontextmenu=new Function("event.returnValue=false");
    document.onselectstart=new Function("event.returnValue=false");
    document.oncontextmenu=function(){return false;}

    this.changeTab(this.$route.name);
  },
  data() {
    return {
      fab: false,
      footerbottom: 0,
      menus: [
        { value: 1, routerName: '/', title: '福曼珊', tip:"首頁",icon: 'mdi-home'},
        { value: 1, routerName: 'about', title: '發現兒童', tip: '園所介紹', icon: 'mdi-home'},
        { value: 2, routerName: 'teacher', title: '教育與和平', tip: '師資陣容', icon: 'mdi-delete' },
        { value: 3, routerName: 'montessori', title: '吸收性心智', tip: '蒙特梭利教學' , icon: 'mdi-help-circle'},
        { value: 4, routerName: 'school', title: '教學的新視野', tip: '校園生活' , icon: 'mdi-calendar'},
        { value: 5, routerName: 'album', title: '童年之秘', tip: '校園花絮' , icon: 'mdi-music-note'},
        { value: 6, routerName: 'contact', title: '聯絡我們', tip:  '聯絡我們', icon: 'mdi-human-male-female' },
        { value: 7, routerName: 'afterschool', title: '宇宙教育', tip: '課後照顧班' , icon: 'mdi-email'},

      ],
     
    };
  },
  computed: {
    footerStyles() {
      return {
        "bottom": `${this.footerbottom}px`
      };
    }
  },
  methods: {
    resize() {
      var windowWidth = window.innerWidth;
      if(windowWidth < 600)
        this.footerbottom = -250;
    },
    changeTab(name) {
      if(name == '/' || name == 'home' || (name == 'contact' && window.innerWidth>600))
        this.footerbottom = 0;
      else
        this.footerbottom = -180;

      var hasyscroll = document.body.scrollHeight >= (window.innerHeight || document.documentElement.clientHeight);
      if(!hasyscroll)
        this.footerbottom = 0;
      //console.log('H ' +window.innerHeight);
      //console.log(document.body.scrollHeight);
      //console.log(this.footerbottom);
      this.toTop();
      
    },
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    },
  }
  
};
</script>
<style>

.logo-style {
  position: fixed;
  top:0px;
  left: 0px;
  z-index: 20;
  width: 180px;
}

.titleimg-style {
  width: 700px;
}

.backbtn-style {
  position: sticky;
  bottom: 10px;
  
  right: 10%;
  width: 200%;
  z-index: 100;
}
.title-style{
  color: #ff6f00;
  font-weight: bold;
  font-size: 10px;
  height: 100px;
}
.menu-style {
  position: fixed;
  left: 0px;
  top: 100px;
  width: 100%;
  background: #76ff03;
  
  z-index: 10;
  padding-left: 120px;
}

#menus .v-btn {  
  font-size: 20px;
  font-weight: bold;
}
.router-style {
  position: relative;
  top: 150px;
  margin: 8px auto;
  width: 80%;
  border: 0px solid #640028;
}
.footer-style {
  position:absolute;
  width: 100%;

  height: 100px;
}
/*
.smallfooter-style {
  position:absolute;
  width: 100%;
  bottom:-180px;
  height: 160px;
  display: none;
}
*/

@media (max-width:1260px) {
  .router-style {
    top: 150px;
    width: 100%;
    padding: 0;
  }
  .menu-style {
    padding-left: 160px;
  }
}
@media (max-width:1000px) {
  .titleimg-style {
    
    padding-left: 100px !important;
  }
}
@media (max-width:768px) {
  .logo-style {
    width: 80px;
  }
  .titleimg-style {
    width: 350px;
    padding-left: 60px !important;
  }
  .title-style{
    font-size: 20px;
  }
  .menu-style {
    padding-left: 0px;
    top: 50px;
    display: block;
  }

  .router-style {
    width: 100%;
    padding: 0;
    top: 100px;
  }
  .footer-style {
    height: 160px;
    bottom:-250px;
  }
}

</style>
